/* unplugin-vue-components disabled */import { render } from "./Crumbs.vue?vue&type=template&id=90f80136&scoped=true"
import script from "./Crumbs.vue?vue&type=script&lang=js"
export * from "./Crumbs.vue?vue&type=script&lang=js"

import "./Crumbs.vue?vue&type=style&index=0&id=90f80136&lang=less&scoped=true"

import exportComponent from "D:\\云盘\\SynologyDrive\\Synology Drive\\文件\\客户调查表\\customweb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90f80136"]])

export default __exports__